import { getBeehiveSdk } from '../graphql/beehive-sdk'
import { CalculateLeaseInput } from '../../__generated__/beehive'

export async function calculateLease(input: CalculateLeaseInput) {
    const beehive = getBeehiveSdk()

    return await beehive.Calculation({ input })
}
